import { create } from 'zustand';

const useStore = create((set, get) => ({
  cartItems: [],
  messages: [],

  setCart: (items) => set({ cartItems: items }),

  addMessage: (message) => set((state) => ({ messages: [...state.messages, message] })),

  fetchCart: async () => {
    try {
      const response = await fetch('/wp-json/chatbot-pro/v1/cart');
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      get().setCart(data);
    } catch (error) {
      console.error("Failed to fetch cart:", error);
    }
  },
}));

export default useStore;
